import { getProduct } from "../../../../commons/libs/content-service";
import { ProductFilter } from "../../../../commons/specs/filters";
import { Product, ProductId, ProductType } from "../../../../commons/specs/product";
import useQuery, { UseQueryOptions } from "../hooks/use-query";

import { useSettings } from "./use-settings";

type QueryOptions<Type extends ProductType> = Omit<UseQueryOptions<Product<Type>>, "queryKey" | "queryFn">;

interface Arguments<Type extends ProductType> {
  productId: ProductId;
  /** Restricts the returned variants to those matching the filters. */
  filters?: ProductFilter[];
  options?: QueryOptions<Type>;
}

const useProduct = <Type extends ProductType = ProductType>({ productId, filters, options = {} }: Arguments<Type>) => {
  const settings = useSettings();

  const query = useQuery({
    ...options,
    queryKey: ["product", productId, settings.initialized.currency, settings.assortmentPriceSettings, filters],
    queryFn: () => getProduct<Type>(productId, settings.initialized.currency, settings.assortmentPriceSettings, filters)
  });

  return { query };
};

export default useProduct;
